import React from 'react';
import ButtonBase from './ButtonBase';
import { TButtonsDefault } from './types/TButtons';

const Destructive = ({ as = 'button', ...rest }: TButtonsDefault) => (
  <ButtonBase {...rest} as={as} kind="destructive" />
);

export default Destructive;
